/**
 * Знак Seeno. Кольцо берёт currentColor, поэтому знак один на светлую и тёмную
 * обвязку. Зрачок ультрамариновый всегда и не перекрашивается ни на одной
 * поверхности, включая портал агентства.
 */
export function Mark() {
  return (
    <svg className="mk" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="10.5" stroke="currentColor" strokeWidth="2" />
      <circle cx="12" cy="12" r="3.6" fill="#1b39ff" />
    </svg>
  );
}
